export default __webpack_public_path__ + "static/media/logo_toapp.0f6d8c83.png";